import { Component, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef, Renderer2, TemplateRef } from '@angular/core';
import { Topic } from '../topic.interface';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { PreviousDataService } from 'src/app/core/services/previous-gyan/previous-data.service';
import { BreadcrumbService } from '../breadcrumb/breadcrumb.service';
import { CommonServiceService } from 'src/app/core/services/common-service/common-service.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { LocalStorageService } from '../../../core/services/local-storage/local-storage.service';
import { SubmitgyanService } from './../../../core/services/submit-gyan/submitgyan.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-topic-outline',
    templateUrl: './topic-outline.component.html',
    styleUrls: ['./topic-outline.component.scss'],
})
export class TopicOutlineComponent implements OnInit {
    @Input() recentSearchesList!: Array<Topic>;
    @Input() isGridView = true;
    @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;
    @ViewChild('dropdownMenuRef') dropdownMenuRef: any;
    @ViewChild('dropdown') dropdown!: BsDropdownDirective;
    @ViewChild('editTopicEle') editTopicEle!: ElementRef;
    @Output() selectItemParent = new EventEmitter<any>();
    @Output() openMoveModalEvent = new EventEmitter<void>();
    @Output() moveItem = new EventEmitter<void>();
    @ViewChild('deleteGyanModal') deleteGyanModal!: TemplateRef<any>;

    isMobile = window.innerWidth < 768 ? true : false;
    startPage = 0;
    itemsShowLimit: number | undefined;
    currentPath = [];
    currentTopicPath: Array<any> = [];
    showBreadcrumb = true;
    currentFolders = [];
    showMoveLoader = false;
    parentFolderId = null;
    selectedFolderId = null;
    moveError = '';
    CreateFolderPermission: boolean | undefined;
    numChars: number | undefined;
    dynamicClass = 'col-md-12';
    multiSelected: Array<any> = [];
    topicText = '';
    isHoverEffectEnabled = false;
    editGyanPermission = false;
    createGyanPermission = false;
    deleteGyanPermission = false;

    selectedHamburgerRef: any;
    selectedHamburgerGyanId: any;

    topicIdTobeDeleted: any;
    deleteMessage = '';
    currentUser: any;

    faEllipsisV = faEllipsisV;

    newNameadvanceQueery: string = '';
    isTopicLoading = true;

    private modalRef: NgbModalRef | undefined;

    private callAllTopicDataEvent: Subscription;
    private callMoveEvent: Subscription;
    private callDeleteEvent: Subscription;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private previousDataService: PreviousDataService,
        private breadcrumbService: BreadcrumbService,
        private localStorageService: LocalStorageService,
        private authService: AuthService,
        private modalService: NgbModal,
        private toastrService: ToastrService,
        private commonService: CommonServiceService,
        private submitGyanService: SubmitgyanService,
    ) {
        this.callAllTopicDataEvent = this.previousDataService.callAllTopicDataEvent$.subscribe((data) => {
            console.log('callAllTopicDataEvent.data', data);
            this.recentSearchesList = data;
            this.isTopicLoading = false;
        });

        this.callMoveEvent = this.previousDataService.callMoveEvent$.subscribe((data) => {
            console.log('TopicOutlineComponent.callMoveEvent.data', data);
            this.moveGyanItem(data);
        });

        this.callDeleteEvent = this.previousDataService.callDeleteEvent$.subscribe((data) => {
            console.log('TopicOutlineComponent.callDeleteEvent.data', data);
            this.checkForDeleteGyan(data, this.deleteGyanModal);
        });
    }

    ngOnInit() {
        console.log('TopicOutlineComponent.ngOnInit');
        this.currentUser = this.authService.getUserDetails('');
        this.getAccessPermission();
        this.breadcrumbService.currentBreadcrumbs.subscribe((breadcrumbs) => {
            this.currentTopicPath = breadcrumbs;
        });
    }

    getAccessPermission() {
        this.editGyanPermission = this.authService.getAccessList('EditGyan');
        this.deleteGyanPermission = this.authService.getAccessList('DeleteGyan');
        this.createGyanPermission = this.authService.getAccessList('CreateGyan');
        this.CreateFolderPermission = this.authService.getAccessList('CreateFolder');
    }

    notDefaultImage(screenWidth: number) {
        let numChars = 13;
        if (screenWidth > 1600) {
            numChars = 14;
        } else if (screenWidth > 1400) {
            numChars = 5;
        } else if (screenWidth > 1300) {
            numChars = 4;
        } else if (screenWidth > 1200) {
            numChars = 7;
        } else if (screenWidth > 1100) {
            numChars = 13;
        } else if (screenWidth > 950) {
            numChars = 7;
        } else if (screenWidth > 768) {
            numChars = 7;
        } else if (screenWidth < 768) {
            numChars = 20;
        }
        return numChars;
    }

    isDefaultImage(imageUrl: string) {
        if (imageUrl === undefined) return true;
        if (imageUrl) return imageUrl.includes('gyan-card-image.jpg');
        return false;
    }

    gotoSubFolders(item: any) {
        if (!item.editTopic) {
            console.log('gotoSubFolders.item', item);
            this.currentTopicPath.push(item);
            this.breadcrumbService.updateBreadcrumbs(this.currentTopicPath);
            this.parentFolderId = item.topicId;
            this.multiSelected = [];
            this.previousDataService.emitCallTopicDetailsClickEvent(item.topicId);
        }
    }

    clearTopciBreadcrumb() {
        this.currentTopicPath = [];
        this.parentFolderId = null;
        //this.breadcrumbService.updateBreadcrumbs(this.currentTopicPath);
    }

    gotoArticleDetails(item: any) {
        localStorage.setItem('topicUuid', item.topicUuid);
        localStorage.setItem('topicOwnerId', item.topicOwnerId);
        //this.router.navigate(['article/list', item.topicId]);
    }

    menuOpen: boolean = false;
    closeOption() {
        if (this.menuOpen) {
            const optionsMenus = document.querySelectorAll('.comment-box-menu-icon') as NodeListOf<HTMLElement>;
            if (!optionsMenus) return; // Check if optionsBoxes is null
            // Hide all other open options boxes
            optionsMenus.forEach((box) => {
                //if (box !== currentTarget.nextElementSibling) {
                box.classList.remove('comment-box-menu-icon-select');
                //box.previousElementSibling.classList.remove('comment-box-menu-icon-select');
                // }
            });

            const optionsBoxes = document.querySelectorAll('.options-box') as NodeListOf<HTMLElement>;
            if (!optionsBoxes) return; // Check if optionsBoxes is null
            optionsBoxes.forEach((box) => {
                box.classList.remove('show');
            });
            this.menuOpen = false;
        }
    }

    onButtonClick(event: MouseEvent) {
        this.menuOpen = true;
        const currentTarget = event.currentTarget as HTMLElement;
        // console.log(' >> currentTarget << ');
        console.log(currentTarget);
        // console.log(' >> currentTarget << ');
        const x = event.clientX;
        const y = event.clientY;
        //console.log(' >> currentTarget >> x' + x);
        //console.log(' >> currentTarget >> y' + y);
        if (!currentTarget) return; // Check if currentTarget is null
        const optionsBoxes = document.querySelectorAll('.options-box') as NodeListOf<HTMLElement>;
        if (!optionsBoxes) return; // Check if optionsBoxes is null
        // Hide all other open options boxes
        optionsBoxes.forEach((box) => {
            if (box !== currentTarget.nextElementSibling) {
                box.classList.remove('show');
                //box.style.setProperty('left',y.toString());
                //box.previousElementSibling.classList.remove('comment-box-menu-icon-select');
            }
        });

        const optionsMenus = document.querySelectorAll('.comment-box-menu-icon') as NodeListOf<HTMLElement>;
        if (!optionsMenus) return; // Check if optionsBoxes is null
        // Hide all other open options boxes
        optionsMenus.forEach((box) => {
            //if (box !== currentTarget.nextElementSibling) {
            box.classList.remove('comment-box-menu-icon-select');
            //box.previousElementSibling.classList.remove('comment-box-menu-icon-select');
            // }
        });

        const optionsBox = currentTarget.nextElementSibling;
        if (!optionsBox) return; // Check if optionsBox is null
        optionsBox.classList.toggle('show');
        const rect = (event.target as HTMLElement).getBoundingClientRect();
        console.log(' >> rect >> x' + rect);
        //(optionsBox as HTMLElement).style.setProperty('top', '90px');
        //(optionsBox as HTMLElement).style.setProperty('left', ((optionsBox as HTMLElement).getBoundingClientRect().left + window.scrollX).toString() + 'px');

        currentTarget.classList.add('comment-box-menu-icon-select');
        if (optionsBox.classList.contains('show')) {
            this.globalClickListener = this.renderer.listen('document', 'click', (clickEvent: MouseEvent) => {
                if (!optionsBox.contains(clickEvent.target as HTMLElement) && !currentTarget.contains(clickEvent.target as HTMLElement)) {
                    const optionsMenus = document.querySelectorAll('.comment-box-menu-icon') as NodeListOf<HTMLElement>;
                    if (!optionsMenus) return; // Check if optionsBoxes is null
                    // Hide all other open options boxes
                    optionsMenus.forEach((box) => {
                        //if (box !== currentTarget.nextElementSibling) {
                        box.classList.remove('comment-box-menu-icon-select');
                        //box.previousElementSibling.classList.remove('comment-box-menu-icon-select');
                        // }
                    });

                    optionsBox.classList.remove('show');
                    this.globalClickListener(); // Remove the listener once it's no longer needed
                }
            });
        } else {
            if (this.globalClickListener) {
                this.globalClickListener();
            }
        }
    }

    onButtonClick11(event: MouseEvent) {
        const currentTarget = event.currentTarget as HTMLElement;

        // Find the options box (dropdown)
        const optionsBox = currentTarget.nextElementSibling as HTMLElement;
        if (!optionsBox) return;

        // Toggle the visibility of the clicked options box
        optionsBox.classList.toggle('show');

        // Get the bounding rectangle of the ellipsis button
        const rect = currentTarget.getBoundingClientRect();

        // Set the top and left positions of the dropdown relative to the ellipsis button
        optionsBox.style.top = `${rect.bottom + window.scrollY}px`; // Align below the button
        optionsBox.style.left = `${rect.left + window.scrollX}px`; // Align with the left edge of the button

        // Add the 'selected' class to the ellipsis button
        currentTarget.classList.add('comment-box-menu-icon-select');

        // Handle global click to close the dropdown when clicking outside
        if (optionsBox.classList.contains('show')) {
            this.globalClickListener = this.renderer.listen('document', 'click', (clickEvent: MouseEvent) => {
                if (!optionsBox.contains(clickEvent.target as HTMLElement) && !currentTarget.contains(clickEvent.target as HTMLElement)) {
                    optionsBox.classList.remove('show');
                    currentTarget.classList.remove('comment-box-menu-icon-select');
                    this.globalClickListener(); // Remove the listener once it's no longer needed
                }
            });
        } else {
            if (this.globalClickListener) {
                this.globalClickListener();
            }
        }
    }

    private globalClickListener!: () => void;

    topicClicked(event: any, item: any) {
        event.stopPropagation();
        event.preventDefault();
        if (!item.editTopic) {
            //this.topicClicked(item);
            const data = {
                topicName: item.topicName,
                topicId: item.topicId,
                topicStatus: item.topicStatus,
            };
            console.log('topicClicked.data', data);
            this.previousDataService.emitTopicClickEvent(data);
        }
    }

    hamburgerClicked(ref: any, id: any) {
        this.selectedHamburgerRef = ref;
        if (this.selectedHamburgerGyanId != id) {
            this.selectedHamburgerGyanId = id;
        } else {
            this.selectedHamburgerGyanId = null;
        }
    }

    editGyanName(item: any) {
        setTimeout(() => {
            this.selectedHamburgerGyanId = null;
            //   console.log(this.dropdownMenuRef);
            //this.dropdownMenuRef.toggle();
            //this.editTopicEle.nativeElement.focus();
        }, 0);
        this.topicText = item.topicName;
        item.editTopic = !item.editTopic;
    }

    onChangeTopic(item: any) {
        console.log('the edited name is', this.topicText.trim());
        //api Call
        if (this.topicText.trim() && item.topicName != this.topicText) {
            if (item.isFolder) {
                const reqBody = { folderName: this.topicText };
                this.previousDataService.updateFolderName(item.topicId, reqBody).subscribe(
                    (res: any) => {
                        this.handleChangeTopicSuccessResponse(item);
                    },
                    (err: any) => {
                        this.handleChangeTopicErrorResponse(item);
                    },
                );
            } else {
                const reqBody = { id: item.topicId, topicName: this.topicText.trim() };
                this.previousDataService.updateTopicName(reqBody).subscribe(
                    (res: any) => {
                        this.handleChangeTopicSuccessResponse(item);
                    },
                    (err: any) => {
                        this.handleChangeTopicErrorResponse(item);
                    },
                );
            }
        } else {
            item.editTopic = false;
        }
    }

    handleChangeTopicSuccessResponse(item: any) {
        item.editTopic = false;
        item.topicName = this.topicText;
    }

    handleChangeTopicErrorResponse(item: any) {
        item.editTopic = false;
    }

    closeDropdown(dropdown: BsDropdownDirective) {
        dropdown.hide();
        setTimeout(() => {
            this.selectedHamburgerGyanId = null;
        }, 0);
    }

    checkForDeleteGyan(topic: any, content: any) {
        if (topic.isFolder) {
            this.topicIdTobeDeleted = topic.topicId;
            this.callDeleteGyan();
            //this.deleteMessage = 'Are you sure you want to delete this folder?';
        } else {
            const personId = this.authService.getPersonId();
            if (topic.topicOwnerId == personId) {
                if (topic.topicSharedWith.length == 0) {
                    this.deleteMessage = 'Are you sure you want to delete this topic?';
                } else if (topic.topicSharedWith.length > 0) {
                    this.deleteMessage = 'This topic has been shared with other users, Are you sure you want to delete?';
                }
            } else {
                this.deleteMessage = 'Are you sure you want to delete this topic?';
            }
            this.modalRef = this.modalService.open(content, { size: 'sm', centered: true, windowClass: 'custom-modal-class' });
            this.topicIdTobeDeleted = topic.topicId;
        }
    }

    callDeleteGyan() {
        const item = this.recentSearchesList?.find((item) => item.topicId == this.topicIdTobeDeleted);
        if (item?.isFolder) {
            this.previousDataService.deleteFolder(this.topicIdTobeDeleted).subscribe(
                (resp: any) => {
                    //this.handleDeleteGyanSuccessResponse(resp);
                    this.closeOption();
                    const index: any = this.recentSearchesList?.findIndex((selectedTag) => selectedTag.topicId == this.topicIdTobeDeleted);
                    this.recentSearchesList?.splice(index, 1);
                    this.toastrService.success(resp.message);
                    if (this.modalRef) {
                        this.modalRef.close();
                    }
                    const topic = this.currentTopicPath[this.currentTopicPath.length - 1];

                    if (this.currentTopicPath.length > 0) {
                        const topic = this.currentTopicPath[this.currentTopicPath.length - 1];
                        this.previousDataService.emitCallTopicUpdateClickEvent(this.topicIdTobeDeleted, '', 'delete', topic.topicId);
                    } else {
                        this.previousDataService.emitCallTopicUpdateClickEvent(this.topicIdTobeDeleted, '', 'delete', '');
                    }
                },
                (err: any) => {
                    // this.spinnerComponent.hideSpinner();
                    this.toastrService.error(err.error.message);
                    this.handleDeleteGyanErrorResponse();
                },
            );
        } else {
            this.previousDataService.deleteTopic(this.topicIdTobeDeleted, this.authService.getPersonId()).subscribe((data: any) => {
                this.closeOption();
                const index: any = this.recentSearchesList?.findIndex((selectedTag) => selectedTag.topicId == this.topicIdTobeDeleted);
                this.recentSearchesList?.splice(index, 1);
                this.toastrService.success(data.message);
                if (this.modalRef) {
                    this.modalRef.close();
                }
                const topic = this.currentTopicPath[this.currentTopicPath.length - 1];
                if (this.currentTopicPath.length > 0) {
                    const topic = this.currentTopicPath[this.currentTopicPath.length - 1];
                    this.previousDataService.emitCallTopicUpdateClickEvent(this.topicIdTobeDeleted, '', 'delete', topic.topicId);
                } else {
                    this.previousDataService.emitCallTopicUpdateClickEvent(this.topicIdTobeDeleted, '', 'delete', '');
                }
                // if (data.statusCode === 200) {
                //     //this.handleDeleteGyanSuccessResponse(data);
                // } else {
                //     this.handleDeleteGyanErrorResponse();
                // }
            });
        }
    }

    handleDeleteGyanSuccessResponse(data: any) {
        this.closeOption();
        const index: any = this.recentSearchesList?.findIndex((selectedTag) => selectedTag.topicId == this.topicIdTobeDeleted);
        this.recentSearchesList?.splice(index, 1);
        this.toastrService.success(data.message);
        if (this.modalRef) {
            this.modalRef.close();
        }
    }

    handleDeleteGyanErrorResponse() {
        this.closeOption();
        console.log('handleDeleteGyanErrorResponse');
        if (this.modalRef) {
            this.modalRef.close();
        }
    }

    selectItem(item: any) {
        //this.multiSelected.push(item);
        this.selectItemParent.emit(item);
    }
    pushToCWB(item: any) {
        this.closeOption();

        const inputjson = {
            topicId: item.topicId,
            listOfTOCs: [],
        };
        this.previousDataService.pushTopic(inputjson).subscribe((data: any) => {
            if (data) {
                console.log('previousDataService.pushTopic >>>>');
                console.log(data);
                this.toastrService.success(data.message);
            }
        });
    }
    moveGyanItem(item: any) {
        console.log('moveGyanItem.item', item);
        //this.selectItem(item);
        this.moveItem.emit(item);
        this.openMoveModalEvent.emit();
    }

    @ViewChild('renameInputAQ', { static: false }) renameInputAQ?: ElementRef;
    renameAQ(topicId: any, topic: any) {
        this.closeOption();
        topic.editTopic = true;
        this.newNameadvanceQueery = topic.topicName.slice();
        setTimeout(() => {
            this.renameInputAQ?.nativeElement?.focus(); // Focus on the input
        }, 0);
    }

    onRenameAQInputBlur(event: any, nodeId: number, previousGyan: any) {
        event.stopPropagation();
        event.preventDefault();
        console.log('onRenameAQInputBlur');
        this.saveRenameAQ(event, nodeId, previousGyan);
    }

    saveRenameAQ(event: any, nodeId: number, oldName: any) {
        // debugger;
        if (this.newNameadvanceQueery.toString().trim() === '') {
            this.toastrService.error('Please enter name');
        } else {
            // debugger;
            console.log('oldName.newNameadvanceQueery', this.newNameadvanceQueery);
            //oldName.topicName = this.newNameadvanceQueery;
            if (oldName.topicName !== this.newNameadvanceQueery.toString().trim()) {
                console.log(`Renaming node ${nodeId} to ${this.newNameadvanceQueery}`);
                if (oldName.isFolder) {
                    const reqBody = { folderName: this.newNameadvanceQueery };
                    this.previousDataService.updateFolderName(nodeId, reqBody).subscribe(
                        (res: any) => {
                            //this.handleChangeTopicSuccessResponse(oldName);
                            this.toastrService.success(res.message);
                            oldName.editTopic = false;
                            if (this.currentTopicPath.length > 0) {
                                const topic = this.currentTopicPath[this.currentTopicPath.length - 1];
                                this.previousDataService.emitCallTopicUpdateClickEvent(oldName.topicId, this.newNameadvanceQueery, 'rename', topic.topicId);
                            } else {
                                this.previousDataService.emitCallTopicUpdateClickEvent(oldName.topicId, this.newNameadvanceQueery, 'rename', '');
                            }
                        },
                        (err: any) => {
                            //this.handleChangeTopicErrorResponse(oldName);
                            oldName.editTopic = false;
                            this.toastrService.error(err.error.message);
                        },
                    );
                } else {
                    const json1 = {
                        personId: this.authService.getPersonId(),
                        topicId: nodeId,
                        updatedName: this.newNameadvanceQueery,
                    };
                    this.previousDataService.renameAqGyan(json1).subscribe((data: any) => {
                        if (data.statusCode === 200) {
                            this.toastrService.success(data.message);
                            oldName.editTopic = false;
                            if (this.currentTopicPath.length > 0) {
                                const topic = this.currentTopicPath[this.currentTopicPath.length - 1];
                                this.previousDataService.emitCallTopicUpdateClickEvent(json1.topicId, json1.updatedName, 'rename', topic.topicId);
                            } else {
                                this.previousDataService.emitCallTopicUpdateClickEvent(json1.topicId, json1.updatedName, 'rename', '');
                            }
                        } else if (data.statusCode === 500) {
                            this.toastrService.error(data.message);
                        }
                    });
                }
            } else {
                oldName.editTopic = false;
                //this.toastrService.error('Old Topic Name and New Name are same.');
            }
        }
    }

    calculateNumChars() {
        const screenWidth = window.innerWidth;
        let numChars = 13;
        if (screenWidth > 1600) {
            numChars = 35;
        } else if (screenWidth > 1400) {
            numChars = 30;
        } else if (screenWidth > 1300) {
            numChars = 30;
        } else if (screenWidth > 1200) {
            numChars = 28;
        } else if (screenWidth > 1100) {
            numChars = 28;
        } else if (screenWidth > 850) {
            numChars = 20;
        } else if (screenWidth > 768) {
            numChars = 15;
        } else if (screenWidth < 768) {
            numChars = 30;
        }
        return numChars;
    }

    useAsTemplate(topicId: any) {
        // calling subject to call function use as template and move to cerate gyan page
        this.commonService.setCallUseAsTemplate(topicId);
    }

    ngOnDestroy() {
        if (this.globalClickListener) {
            this.globalClickListener();
        }

        this.callAllTopicDataEvent.unsubscribe();
        this.callMoveEvent.unsubscribe();
        this.callDeleteEvent.unsubscribe();
    }
}
